import { Container } from "@mui/material";
import "./App.css";
import SwitchMode from "./components/ViewMode/SwitchMode";
import { useIsMaintenanceQuery } from "./features/maintenance-check-point/queries/useIsMaintenanceQuery";
import Routing from "./Routing";
import MaintenanceView from "./views/MaintenanceView";

function App() {
  const { data: isMaintenance } = useIsMaintenanceQuery();
  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        p: 3,
        pb: 6,
        height: "100vh",
        maxHeight: "100vh",
      }}
      maxWidth="xl"
    >
      <SwitchMode />
      {isMaintenance === true ? <MaintenanceView /> : <Routing />}
    </Container>
  );
}

export default App;
